import { CaretDown } from "@phosphor-icons/react"
import { Button, Menu, MenuItem, Popover, Toast } from "@vesatogo/grass-core"
import { useReportModal } from "@vesatogo/grass-reportmodal"
import toast from "react-hot-toast"
import { OperationContext } from "urql"
import { useAuthorization } from "~/components/AuthorizationProvider"
import { Permission } from "~/constants/Permissions"
import {
  useAllDepartmentsQuery,
  useSetPlantTransactionInactiveMutation,
} from "~/generated/graphql"
import { useSettlementSelectorList } from "~/store/settlement-selector.store"

const ReceivableActions = ({
  refetch,
}: {
  refetch: (opts?: Partial<OperationContext> | undefined) => void
}) => {
  const onOpen = useReportModal(store => store.onOpen)
  const { selected, reset } = useSettlementSelectorList()
  const disableInactivate = Object.values(selected)?.some(
    d =>
      d?.transactions?.[0]?.child_transactions_aggregate?.aggregate?.sum?.amount
  )

  const canViewPayableReceivableReport = useAuthorization(
    Permission.ViewPayableReceivableReport
  )
  const canSetInactive = useAuthorization(
    Permission.CanInactivatePlantSettlement
  )

  const [, setTxnInactive] = useSetPlantTransactionInactiveMutation()

  const setInActive = async () => {
    const ids = Object.values(selected)?.map(d => d.id)
    const { error } = await setTxnInactive({
      where: {
        id: {
          _in: ids,
        },
      },
    })
    if (error) {
      toast.custom(
        <Toast title={"Something went wrong" + error.message} intent="danger" />
      )
    } else {
      toast.custom(<Toast title="Successfully set inactive!" />)
      reset()
    }
    refetch?.({
      requestPolicy: "cache-and-network",
    })
  }
  return (
    <>
      <Popover
        minimal
        arrow={false}
        className="p-0"
        trigger="click"
        interactive
        animation="fade"
        theme="light-border"
        placement="bottom"
        content={
          <Menu className="max-h-52">
            {canViewPayableReceivableReport && (
              <MenuItem
                onClick={() => {
                  onOpen(
                    [
                      {
                        key: "from_date",
                        label: "Date From",
                        type: "date",
                      },
                      {
                        key: "till_date",
                        label: "Date Till",
                        type: "date",
                      },
                      {
                        key: "payable_report_name",
                        label: "Receivable Report Name",
                        placeholder: "Select Receivable Report Name",
                        type: "staticSelect",
                        options: [
                          {
                            id: "plant_settlement_report",
                            name: "Plant Settlement Report",
                          },

                          {
                            id: "receivable_settlement_report",
                            name: "Receivable Settlement Report",
                          },
                          {
                            id: "receivable_settlement_outstanding_report",
                            name: "Receivable Settlement Outstanding Report",
                          },
                        ],
                      },
                      {
                        key: "department",
                        label: "Department",
                        placeholder: "Select Department",
                        type: "querySelect",
                        dataHook: useAllDepartmentsQuery,
                      },
                    ],
                    `https://${
                      import.meta.env.VITE_REST_URL
                    }/reports/payable_receivable_report_email?department_settlement_kind=credit`,
                    {
                      multipleEmails: true,
                      successMessage: "Receivable Report sent successfully",
                    }
                  )
                }}
              >
                Receivable Report
              </MenuItem>
            )}
            {canSetInactive && (
              <MenuItem
                onClick={() => {
                  setInActive()
                }}
                disabled={disableInactivate}
              >
                Set Transactions Inactive
              </MenuItem>
            )}
          </Menu>
        }
      >
        <Button
          className="!bg-gray-300"
          intent="none"
          leftIcon={<CaretDown weight="fill" />}
        >
          Action
        </Button>
      </Popover>
    </>
  )
}

export default ReceivableActions
